import { SUPPLY_DEMAND_SIGNAL_DETAIL_TYPES } from "./supplyDemandSignalDetailTypes";

/** Values match NOTIFICATION_TAG_TYPES used by web/native NotificationTag. */
export const SUPPLY_DEMAND_NOTIFICATION_TAG_TYPES = {
  ALERT: "alert",
  SIGNAL: "signal"
};

export function getSupplyDemandNotificationTags(config, translate) {
  if (!config) {
    return [];
  }

  if (config.detail_type === SUPPLY_DEMAND_SIGNAL_DETAIL_TYPES.ENTRY) {
    return [
      {
        text: translate("Buy"),
        type: SUPPLY_DEMAND_NOTIFICATION_TAG_TYPES.SIGNAL
      }
    ];
  }

  if (config.detail_type) {
    return [
      {
        text: translate("close"),
        type: SUPPLY_DEMAND_NOTIFICATION_TAG_TYPES.ALERT
      }
    ];
  }

  return [];
}
